import * as React from 'react'
import styled, { css } from 'styled-components'
import { Style } from '../../styles'
import { Pagination as PaginationType } from '../../types'
import Pagination from '../Pagination/Pagination'
import ButtonGroup, { ButtonGroupItem } from '../Button/ButtonGroup'
import ResourceColumnSettings from './ResourceColumnSettings'

const Container = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: ${Style.spacing.x2};
	flex-wrap: wrap;
	padding: ${Style.spacing.x1_5};
	background: white;
	color: #637381;
	text-align: center;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	border-top: 1px solid ${Style.color.border};
`

const FooterLeft = styled.div`
	flex: 1;
`

const FooterRight = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	flex: 1;
`

interface IProps {
	itemCount: number
	pagination?: PaginationType
	columns?: { label: string, value: string }[]
	selectedColumns?: string[]
	onPageChange?: (page: number) => void
	onPerPageChange?: (perPage: number) => void
	onColumnsChange?: (columns: string[]) => void
}

export default class ResourceFooter extends React.PureComponent<IProps> {
	render() {
		const {
			itemCount,
			pagination,
			columns,
			selectedColumns,
			onPageChange,
			onPerPageChange,
			onColumnsChange
		} = this.props

		const onPaginationPageChange = (selectedPage: { selected: number }) => {
			const newPage = selectedPage.selected + 1
			if (onPageChange) onPageChange(newPage)
		}

		const onPaginationPerPageChange = (newPerPage: number) => {
			if (onPerPageChange) onPerPageChange(newPerPage)
		}

		if (itemCount > 0 && pagination) {
			const { page, pageCount, perPage } = pagination

			const perPageOptions: ButtonGroupItem[] = [25, 50, 100].map(value => {
				return { element: <>{value}</>, active: perPage === value, onClick: () => onPaginationPerPageChange(value) }
			})

			return (
				<Container>
					<FooterLeft>
						<Pagination
							forcePage={page}
							pageCount={pageCount}
							onPageChange={onPaginationPageChange}
							disableInitialCallback={true}
						/>
					</FooterLeft>
					<FooterRight>
						{onPerPageChange && <ButtonGroup
							items={perPageOptions}
						/>}

						{columns && selectedColumns && onColumnsChange && <ResourceColumnSettings
							columns={columns}
							activeColumns={selectedColumns}
							onChange={onColumnsChange}
						/>}
					</FooterRight>
				</Container>
			)
		}

		return null
	}
}